import { useSelector } from 'react-redux';
import { getX50UntilTime } from '../selectors';
import { IStore } from 'store/interface';

export const useGameUntilTime = () =>
  useSelector<IStore, IStore['x50']['timeOldEnds']>(getX50UntilTime);
